var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.873439 9.85471C0.873439 10.1789 1.00079 10.4897 1.22749 10.719C1.45418 10.9482 1.76164 11.0769 2.08223 11.0769H6.91739C7.23799 11.0769 7.54545 10.9482 7.77214 10.719C7.99883 10.4897 8.12619 10.1789 8.12619 9.85471V2.52138L0.873439 2.52138L0.873439 9.85471ZM2.08223 3.7436L6.91739 3.7436L6.91739 9.85471H2.08223L2.08223 3.7436ZM6.6152 0.688046L6.0108 0.0769348L2.98882 0.0769348L2.38443 0.688046L0.269043 0.688046L0.269043 1.91027L8.73058 1.91027V0.688046L6.6152 0.688046Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a8fc7fa4.svg";
export { ForwardRef as ReactComponent };